import Vue from 'vue'
import Vuex from 'vuex'

import actions from './actions'
import users from './modules/users'
import auth from './modules/auth'
import vehicles from './modules/vehicles'
import sessions from './modules/sessions'
import calibrations from './modules/calibrations'
import engines from './modules/engines'
import demo from './modules/demo'

import createLogger from '../plugins/logger'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state: {
    api: {
      host:
        process.env.NODE_ENV !== 'production'
          ? 'https://shipping.emissionmonitor.eu/rest_api'
          : '/rest_api',
      endpoints: {
        auth: 'api_token_auth',
        user: 'user_details',
        vehicle: 'vehicles',
        vehicles: 'deep_vehicles',
        engines: 'engines',
        sessions: 'sessions',
        deepSessions: 'deep_sessions',
        sessionStatistics: 'session_statistics',
        calibrations: 'calibrations',
        ld: 'lds',
        hd: 'hds',
        barge: 'barges',
        export: 'export_sems_data',
        map: 'map_data',
        demo: 'demo'
      }
    }
  },
  modules: {
    users,
    auth,
    vehicles,
    sessions,
    engines,
    calibrations,
    demo
  },
  actions,
  strict: debug,
  plugins: debug ? [createLogger()] : []
})



// WEBPACK FOOTER //
// ./src/store/index.js